module.exports = __webpack_public_path__ + "img/icon-redy-small.ca387d39.svg";